import { __assign } from "tslib";
import * as React from 'react';
import { memo } from 'react';
var SvgArrowheadDown = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", "data-test-id": "icons-arrowhead-down", viewBox: "0 0 24 24", role: "img" }, props),
    React.createElement("title", null, 'Arrowhead Down Icon'),
    React.createElement("path", { fill: "currentColor", d: "M12.516 14.766a.686.686 0 0 1-1.032 0l-2.365-2.6-1.96-2.153C6.82 9.64 7.06 9 7.542 9h8.918c.481 0 .722.64.382 1.013l-1.96 2.153-2.365 2.6" }))); };
var Memo = memo(SvgArrowheadDown);
export default Memo;
//# sourceMappingURL=ArrowheadDown.js.map